import { trimObjectStrings } from '../utils/stringUtils';
import { backendFetch } from './apiUtils';

export const getPoNumberFromJiraTicket = async (jiraTicket) => {
  /** returns a PO Number for freshways - based on the Jira Ticket number provided */
  return await backendFetch({
    url: 'businessPartner/freshwaysPo',
    params: { jiraTicket },
    method: 'GET',
  });
};

export const getBusinessPartner = async (detail, id) => {
  if (detail === 'Contacts' && !id) {
    return Array.from({ length: 5 }, () => ({ contactName: '', contactEmail: '' }));
  }

  const businessPartnerDetailsUrls = {
    Company: 'businessPartner/company',
    'Main Contact Details': 'businessPartner/mainContactDetails',
    'Business Partner': 'businessPartner/businessPartner',
    Address: 'businessPartner/address',
    Contacts: 'businessPartner/contacts',
    'Billable Settings': 'businessPartner/billableSettings',
    'Company Payment Details': 'businessPartner/companyPaymentDetails',
    'Authorisation Documents': 'businessPartner/authorisationDocuments',
    'Customs Authorisations': 'businessPartner/customsAuthorisations',
    'tabs info': 'businessPartner/PartnerStatus',
    'Trader Data': 'businessPartner/traderData',
    'Trader Settings': 'businessPartner/traderSettings',
    Parents: 'businessPartner/ParentById',
    Defaults: 'businessPartner/defaultDetails',
  };

  const params = {
    id,
    ...(detail === 'Parents' && { onlyChecked: 0 }),
  };

  const url = businessPartnerDetailsUrls[detail] || 'businessPartner/company';

  return await backendFetch({
    url,
    params,
    method: 'GET',
  });
};

export const putBusinessPartner = async (data, activeStep, id) => {
  const putBusinessPartnerUrls = {
    BPcompanydetails: 'businessPartner/companyDetails',
    BPaddress: 'businessPartner/address',
    BPContacts: 'businessPartner/contacts',
    BPBillingDetails: 'businessPartner/billingDetails',
    BPCustomsAndCompliance: 'businessPartner/customsCompliance',
    BPCabie: 'businessPartner/traderData',
    BPDefaults: 'businessPartner/defaults',
  };

  const url = putBusinessPartnerUrls[activeStep];
  const trimmedData = trimObjectStrings(data);

  return backendFetch({
    url,
    method: 'PUT',
    params: { id },
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(trimmedData),
    },
  });
};

export const getBusinessPartnerDefaults = async (id) => {
  return await backendFetch({
    url: `businessPartner/defaults/${id}`,
    method: 'GET',
  });
};

export const syncBusinessPartnerToJira = async (neenorId) => {
  return backendFetch({
    url: 'businessPartner/syncToJira',
    params: { neenorId },
    method: 'GET',
  });
};
